export type GameHistoryEvents = {
    'General.GameHistory.Opened': void;
    'General.GameHistory.Closed': void;
};